<template>
  <footer class="footer">
    <span>&copy; {{ new Date().getFullYear() }} Prasham Tated</span>
    .
    <a target="_blank" rel="noopener" href="https://linkedin.com/in/prashamtated" title="LinkedIn">LinkedIn</a>
    .
    <a target="_blank" rel="noopener" href="https://github.com/prashamtated" title="GitHub">GitHub</a>
    .
    <a target="_blank" rel="noopener" href="https://prashamtated.goatcounter.com" title="View visitor analytics">
      <img
        src="https://api.visitorbadge.io/api/visitors?path=https%3A%2F%2Fwww.prasham.com&label=Visitors&countColor=%23263759&style=flat-square"
        alt="Visitor Count"
        class="visitor-badge"
      />
    </a>
  </footer>
</template>

<script>
export default {
  name: 'FooterBar'
}
</script>

<style scoped>
.visitor-badge {
  height: 20px;
  vertical-align: middle;
  margin-left: 2px;
}
</style>
